import axios from "axios";
import { config } from "./const";

// Adjusted to be a function that can be called to initiate the fetch
export const fetchYourStories = async () => {
  try {
    const email = localStorage.getItem("email");
    // Attempt to load cached stories first

    const response = await axios.get(
      `${config.backend_url}/user/getStories?email=${email}`
    );
    const stories = response.data.stories;
    console.log(stories);

    // Cache the fetched stories

    return stories;
  } catch (error) {
    console.error(error);
    return []; // Return an empty array or appropriate error handling
  }
};

export const fetchPublicStories = async () => {
  try {
    const email = localStorage.getItem("email");
    const response = await axios.get(
      `${config.backend_url}/user/getStoryPublic?email=${email}`
    );
    const stories = response.data.stories;
    console.log(stories[0].user.name);
    const cachedStories = localStorage.getItem("stories");
    if (cachedStories) {
      console.log("Loading stories from cache");
      return JSON.parse(cachedStories); // Parse and return the cached stories
    }
    // Cache the fetched stories
    return stories;
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const fetchLikedStories = async () => {
  try {
    const email = localStorage.getItem("email");
    const response = await axios.get(
      `${config.backend_url}/user/getLikedStories?email=${email}`
    );
    const stories = response.data.stories;
    console.log(stories);
    const cachedStories = localStorage.getItem("stories");
    if (cachedStories) {
      console.log("Loading stories from cache");
      return JSON.parse(cachedStories); // Parse and return the cached stories
    }
    // Cache the fetched stories
    return stories;
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const fetchQuestions = async (req) => {
  try {
    console.log(req, "req");
    const id = req.id;
    const response = await axios.get(
      `${config.backend_url}/getJustQuestions?storyId=${id}`
    );
    const questions = response.data.questions;
    console.log(questions);
    return questions;
  } catch (error) {
    console.error(error);
    return [];
  }
};

// export const storyList = fetchStories();
// console.log(storyList);

export const loginsuccess = {
  value: 0,
  set loginsuccess(val) {
    this.value = val;
  },
  get loginsuccess() {
    return this.value;
  },
};

export const saved = {
  save: [],
  set saved(val) {
    this.save.push(val);
  },
  get saved() {
    return this.save;
  },
};
